export const NO_LOT = 'Sin partida'
